import { Card, CardContent, CardActions, Button, Chip } from "@mui/material";
import { useGetUser } from "hooks/useGetUser";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";
import usersService from "services/usersService";
import { ADMIN_HOME_PATH } from "helpers/url";

export const SelectOrg = () => {
  const navigate = useNavigate();
  const { data: user, isFetchedAfterMount, refetch } = useGetUser();
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Организации пользователя. Последняя выбранная — первой
  const members: any[] = (user?.members || [])
    .filter((member: any) => member.org)
    .sort((a: any, b: any) => Number(b.orgID === user?.lastOrgID) - Number(a.orgID === user?.lastOrgID));

  const selectOrg = async (orgID: string) => {
    if (isSaving) return;
    setIsSaving(true);
    localStorage.setItem("orgID", orgID);
    try {
      await usersService.updateLastOrg(orgID);
    } catch (ex) {
      // Не блокируем вход, если не удалось запомнить выбор
      console.error("updateLastOrg ex: ", ex);
    }
    window.location.href = ADMIN_HOME_PATH;
  };

  useEffect(() => {
    // Если организация одна — выбираем её сразу
    if (isFetchedAfterMount && members.length === 1) {
      selectOrg(members[0].orgID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isFetchedAfterMount]);

  // Ждём свежие данные, чтобы не показать организации из кеша другого пользователя
  if (!isFetchedAfterMount || !user) {
    return <div>Загрузка...</div>;
  }

  return (
    <div className="flex flex-col gap-4 md:w-1/2 mx-auto">
      <h1 className="text-2xl font-bold">Пожалуйста, выберите организацию</h1>
      <Card>
        <CardContent>
          {members.length === 0 && (
            <div className="text-gray-500">Вы не состоите ни в одной организации</div>
          )}
          {members.map((member: any, index: number) => (
            <div key={member.id}>
              <div
                className={`flex gap-4 items-center py-2 ${isSaving ? "opacity-50" : "cursor-pointer"}`}
                onClick={() => selectOrg(member.orgID)}
              >
                <div className="w-[80px] h-[80px]">
                  {member.org.logo && (
                    <img
                      src={member.org.logo}
                      alt={member.org.name}
                      className="w-100 h-100 object-contain"
                    />
                  )}
                </div>
                <div className="text-lg font-bold text-blue-500 hover:text-blue-700">
                  {member.org.name}
                </div>
                {member.orgID === user.lastOrgID && (
                  <Chip label="Последняя" size="small" color="primary" variant="outlined" />
                )}
              </div>
              {index !== members.length - 1 && (
                <div className="border-b border-gray-300 w-full"></div>
              )}
            </div>
          ))}
        </CardContent>
        <CardActions>
          <div className="w-full p-8">
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={() => navigate("/auth/logout")}
              className="flex items-center gap-2"
            >
              <FaSignOutAlt />
              Выйти
            </Button>
          </div>
        </CardActions>
      </Card>
    </div>
  );
};
